const PATHS = {
  HOME: '/',
  HELP: '/help',
  NOT_FOUND: '*',
  MEDIA: '/media',
  SIGN_UP: '/signup',
  PROFILE: '/profile',
  CONTACT_US: '/contact-us',
  QUICK_LINKS: '/quick-links',
  MANAGE_USERS: '/manage-users',
  WEB_CAST_VIDEO: '/webcast-video',
  // MANAGE_PROFILE: '/manage-profile',
  CHANGE_PASSWORD: '/change-password',
  BIBLE_SEMINARS: '/bible-seminars',
  WEB_CAST_SIGN_IN: '/webcast-signin',
  WEB_CAST_USAGE: '/webcast-usage',
  WHAT_WE_BELIEVE: '/what-we-believe',
  RESET_PASSWORD: '/set-new-password',
  UNAUTHORIZED: '/unauthorized-access',
  ECCLESIAL_DOCUMENT: '/ecclesial-documents',
  RESET_PASSWORD_SUCCESS: '/password-reset-success',
  VIDEO_PLAYER: '/media/video/:videoId',
  MANAGE_PROFILE: '/manage-profile/:profileId',
  VIDEO_TAB: '/media/video',
  AUDIO_TAB: '/media/audio',
  USERS_TAB: '/dashboard/manage-users',
  USAGE_TAB: '/dashboard/webcast-usage',
  PUBLIC_EVENTS_TAB: '/dashboard/public-events',
  BIBLE_SEMINARS_TAB: '/dashboard/manage-bible-seminars',
  ADMIN_BIBLE_SEMINARS: '/dashboard/manage-bible-seminars',
  RESOURCES: '/resources',
  SYLLABUS: '/syllabus',
  ADMINEVENTS: '/dashboard/public-events',
  PUBLIC_EVENTS: 'public-events-list',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_USE: '/terms-of-use'
};

export default PATHS;
